<mulo-prologue class="margin-bottom-md">
  <mulo-centered-block-layout [width]="700" class="units-header">
    <div class="title-wrap">
      <mat-icon muloSvgViewbox svgIcon="graph-outline"></mat-icon>
      <h1>{{ 'research.portal.academic.units.title' | translate }}</h1>
    </div>
  </mulo-centered-block-layout>
</mulo-prologue>
<mulo-centered-block-layout [width]="700">
  @if (loading) {
    <mulo-loading-slate></mulo-loading-slate>
  }
  @if (dataNodes?.length > 0) {
    <button
      (click)="handleExpandCollapse()"
      class="expand-collapse-btn has-icon"
      color="primary"
      mat-button
      >
      @if (treeExpanded) {
        <mat-icon svgIcon="unfold-less-horizontal"></mat-icon>
        <span>{{ 'research.portal.orgUnits.collapseAll' | translate }}</span>
      } @else {
        <mat-icon svgIcon="unfold-more-horizontal"></mat-icon>
        <span>{{ 'research.portal.orgUnits.expandAll' | translate }}</span>
      }
    </button>
  }
  @if (showFindBox && dataNodes?.length > 0) {
    <mulo-separator [length]="24" orientation="vertical"></mulo-separator>
  }
  @if (showFindBox && unitNodes?.length > 0) {
    <mat-form-field
      appearance="outline"
      class="is-inline no-subscript find-field"
      >
      <mat-label>{{ 'research.portal.orgUnits.find' | translate }}</mat-label>
      <input [formControl]="findControl" matInput />
      <mat-icon matSuffix muloSvgViewbox svgIcon="magnify"></mat-icon>
    </mat-form-field>
  }
  <mat-tree
    [attr.aria-label]="'research.portal.academic.units.title' | translate"
    [dataSource]="dataSource"
    [treeControl]="treeCtrl"
    espMatTreeChildKey="children"
    >
    <mat-tree-node *matTreeNodeDef="let node">
      <div class="mat-tree-node-content unit-line" [id]="node.value?.code">
        <a
                    [innerHTML]="
                        (node.value?.code | translate) || node.value?.displayName | muloHighlightText: findControl.value
                    "
          [queryParams]="unitLinkQueryParamsNew(node)"
          [routerLink]="unitSearchLink(node.value)"
          class="hasnt-color semibold"
          espNodeContent
        ></a>
        @if (node.value?.displayHomePage) {
          <mat-icon
                    [attr.aria-label]="
                        'esploro.research.conf.research.portal.label.prefix.orgTree.tab.homepage' | translate
                    "
            class="homepage-icon"
            muloSvgViewbox
            svgIcon="home"
          ></mat-icon>
        }
      </div>
    </mat-tree-node>
    <!-- Below is the tree node template for expandable nodes -->
    <mat-nested-tree-node
      *matTreeNodeDef="let node; when: hasChildNew"
      [class.has-description]="node.level === 0"
      [class.is-expanded]="treeCtrl.isExpanded(node)"
      >
      <div class="mat-tree-node">
        <button
          [attr.aria-label]="'toggle ' + node.value?.displayName"
          [tabindex]="-1"
          mat-icon-button
          matTreeNodeToggle
          >
          <span class="mdc-button__label">
            <mat-icon
              [class.is-expanded]="treeCtrl.isExpanded(node)"
              [svgIcon]="treeCtrl.isExpanded(node) ? 'minus' : 'plus'"
              class="mat-icon-rtl-mirror"
              >
            </mat-icon>
          </span>
        </button>
        <div class="mat-nested-tree-node-content">
          <div class="unit-line" [id]="node.value?.code">
            <a
                            [innerHTML]="
                                (node.value?.code | translate) || node.value?.displayName
                                    | muloHighlightText: findControl.value
                            "
              [queryParams]="unitLinkQueryParamsNew(node)"
              [routerLink]="unitSearchLink(node.value)"
              class="hasnt-color semibold"
              espNodeContent
            ></a>

            @if (node.value?.displayHomePage) {
              <mat-icon
                            [attr.aria-label]="
                                'esploro.research.conf.research.portal.label.prefix.orgTree.tab.homepage' | translate
                            "
                class="homepage-icon"
                muloSvgViewbox
                svgIcon="home"
              ></mat-icon>
            }
          </div>
          @if (!treeCtrl.isExpanded(node) && node.level === 0) {
            <div
                        [@heightInAnimation]="{
                            value: 'enter',
                            params: { opacityFrom: 0, opacityTo: 1, time: '.3s' }
                        }"
                        [@heightOutAnimation]="{
                            value: 'leave',
                            params: { opacityFrom: 1, opacityTo: 0, time: '0s' }
                        }"
              class="mat-tree-node-description"
              >
              <div class="margin-bottom-xs">
                @for (child of node.children; track child.value?.code) {
                  <span
                    [innerHTML]="child.value?.code | translate | muloHighlightText: findControl.value"
                  ></span>
                  @if (!$last) {
                    ,&nbsp;
                  }
                }
              </div>
            </div>
          }
        </div>
      </div>

      <div
        [@growInAnimation]="{ value: 'enter', params: { origin: '0 -5rem' } }"
        [@growOutAnimation]="{ value: 'leave', params: { origin: '0 -15rem' } }"
        [class.tree-invisible]="!treeCtrl.isExpanded(node)"
        role="group"
        >
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</mulo-centered-block-layout>
